import React from "react";

function TitleComponent(props) {

    return (
        <div className="custom-order-title-l1">{props.title}</div>
    );
}

export default TitleComponent;






